import { render, staticRenderFns } from "./CrewLicense.vue?vue&type=template&id=63709aa7&scoped=true&"
import script from "./CrewLicense.vue?vue&type=script&lang=js&"
export * from "./CrewLicense.vue?vue&type=script&lang=js&"
import style0 from "./CrewLicense.vue?vue&type=style&index=0&id=63709aa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63709aa7",
  null
  
)

export default component.exports